let damagereportlist = [
  "Broken",
  "Burnt",
  "Cracked",
  "Ripped",
  "Opened",
  "Other",
];
export default damagereportlist;
